export const lifeAtBitsclanData = {
  banner: {
    heading: "Where Dreamers Find Their Drive & Innovators",
    subHeading: "Become Changemakers",
    paragraphOne:
      "At Bitsclan, we believe in fostering an environment where innovation thrives & careers flourish. Our team is a diverse group of talented professionals, united by a passion for technology & a commitment to excellence. Here, every project is a chance to push boundaries, every challenge is a pathway to growth, & every team member is empowered to lead.",
    paragraphTwo:
      "We offer opportunities to develop your skills, & make a real impact. Discover what life at Bitsclan is all about & take the next step in your career with us.",
  },

  meetOurTeam: {
    heading: "We Work Hard & Play Harder",
    paragraphOne:
      "Our work ethic is built on dedication, collaboration, & excellence—but we also know how to have a good time. Whether it’s intense matches on the in-house table tennis court, friendly PS5 gaming competitions, or enjoying dinners together, we make sure there’s always time to unwind & have fun. ",
    paragraphTwo:
      "Our vibrant workplace culture fosters not just hard work, but also camaraderie & relaxation, making Bitsclan a place where you can thrive professionally while enjoying the journey.",
  },

  ceoIntro: {
    heading: "M Awais Sarwar",
    subHeading:
      "I have drastically improved my soft skills by attending various hands-on trainings. I am more confident & have stronger relationships with clients & my colleagues.",
  },

  perksAndBenefit: {
    heading: "Perks &",
    coloredHeading: "Benefits",
    paragraph:
      "We believe that our people are our greatest asset, & we’re committed to providing a supportive & rewarding work environment. We offer a range of perks & benefits designed to enhance your well-being, recognize your hard work, & celebrate your milestones. When you join Bitsclan, you’re not just gaining a job—you’re joining a community that values your contributions & supports your growth.",
    benefits: [
      {
        title: "Health Insurance",
        description: "Comprehensive health coverage for you & your family, ensuring peace of mind & well-being.",
        icon: "prek-iocn1.svg"
      },
      {
        title: "Paid Time Off (PTO)",
        description: "Flexible paid leave policy that lets you take time off for rest, travel, or personal needs.",
        icon: "prek-iocn2.svg"
      },
      {
        title: "Remote & Hybrid Work Flexibility",
        description: "Work from where you're most productive, with the flexibility to balance your professional & personal life.",
        icon: "prek-iocn3.svg"
      },
      {
        title: "Learning & Development",
        description: "Access to training programs, workshops, & courses to help you grow your skills & advance your career.",
        icon: "prek-iocn4.svg"
      },
      {
        title: "Performance Bonuses",
        description: "Be rewarded for your impact & contributions through performance-based bonuses.",
        icon: "prek-iocn5.svg"
      },
      {
        title: "Wellness Programs",
        description: "Initiatives to support your physical & mental health, from fitness reimbursements to wellness resources.",
        icon: "prek-iocn6.svg"
      },
      {
        title: "Team Events & Annual Gatherings",
        description: "Celebrate milestones & strengthen bonds with regular team-building activities & annual company events.",
        icon: "prek-iocn7.svg"
      },
      {
        title: "Recognition & Celebrations",
        description: "From birthdays to work anniversaries, we make sure achievements & milestones are always recognized.",
        icon: "prek-iocn8.svg"
      }
    ],
    joinOurTeamButton: "Join our team",
  },

  lifeGallery: {
    heading: "Life at Bitsclan",
    subHeading:
      "At Bitsclan IT Solutions, we believe our greatest strength is our people. Beyond delivering world-class software development, AI solutions, & enterprise IT services, we foster a culture where creativity, collaboration, & growth thrive. Our work environment balances professional excellence with personal well-being, making Bitsclan more than just a workplace it’s a community.",
  },
  partnersAndTeam: {
    heading: "Awards & Partnerships",
    subHeading: "Collaborative Excellence: Building Bridges, Driving Success",
    description:
      "Empowering partnersships & fostering teamwork to achieve unparalled excellence. Our dedicated approach & shared vision create a synergy that fuels innovation & drives sustainable success for all.",
    btnHeading: "Join the partners network",
    btnText: "Become a partner",
  },
};
